import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import "./Register.css";

const Register = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [email, setEmail] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [isDisclaimerOpen, setIsDisclaimerOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    // Get referral code from URL
    const params = new URLSearchParams(location.search);
    const ref = params.get("ref");
    if (ref) {
      setReferralCode(ref);
    }
  }, [location]);

  const handleRegister = async (e) => {
    e.preventDefault();
    setMessage(null);
    setError(null);

    try {
      const response = await axios.post(
        "https://lionfish-app-w73zu.ondigitalocean.app/api/register/",
        {
          username,
          password,
          confirm_password: confirmPassword,
          email,
          referral_code: referralCode // Include referral code if present
        }
      );

      setMessage("User Created - Redirecting to login...");

      // Wait 2 seconds before redirecting to the login page
      setTimeout(() => {
        navigate("/login");
      }, 2000);

    } catch (error) {
      console.error("Registration failed:", error);
      if (error.response?.data?.errors) {
        setError("Error: " + JSON.stringify(error.response.data.errors));
      } else {
        setError("An unexpected error occurred. Please try again.");
      }
    }
  };

  const toggleDisclaimer = () => {
    setIsDisclaimerOpen(!isDisclaimerOpen);
  };

  return (
    <div className="register-container">
      {message && <p className="register-success">{message}</p>}
      {error && <p className="register-error">{error}</p>}

      {/* Referral Banner - Show when referral code is present */}
      {referralCode && (
        <div className="referral-banner">
          You were referred by a friend! Complete signup to give them a reward.
        </div>
      )}

      <form onSubmit={handleRegister} className="register-form">
        <h2 className="register-header">Create Account</h2>
        <input
          className="register-input"
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Username"
          required
        />
        <input
          className="register-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          required
        />
        <input
          className="register-input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          required
        />
        <input
          className="register-input"
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="Confirm Password"
          required
        />
        <button type="submit" className="register-button">Register</button>
      </form>
      <p className="register-footer">
        Already have an account? <Link to="/login">Login</Link>
      </p>

      {/* Collapsible Disclaimer Section */}
      <div className="disclaimer-container">
        <div className="disclaimer-header" onClick={toggleDisclaimer}>
          <div className="icon">
            <span>ℹ️</span>
            <span>Important Disclaimer</span>
          </div>
          <span className="toggle-icon">{isDisclaimerOpen ? '▲' : '▼'}</span>
        </div>

        {isDisclaimerOpen && (
          <div className="disclaimer-content">
            <p>
              By accessing this site, you agree to our <Link to="/termsofservice">Terms of Service</Link>.
            </p>

            <p>
              <strong>PrivateIQ</strong> is an independent platform that provides a directory and review service for
              individuals.
              In addition, we provide private clubs we partner with the opportunity to connect with potential members in
              their area,
              <strong> at the discretion of the individual.</strong>
            </p>

            <p>
              All information provided is for general informational purposes only and should be independently verified.
              PrivateIQ does not guarantee the accuracy, completeness, or reliability of any club-related details,
              including but not limited to:
            </p>

            <ul>
              <li><strong>Membership fees</strong></li>
              <li><strong>Amenities</strong></li>
              <li><strong>Access policies</strong></li>
            </ul>

            <p>
              Information may be outdated, incomplete, or subject to change without notice.
            </p>

            <p>
              PrivateIQ assumes no responsibility for any decisions made based on the content provided on this site.
              Users should conduct their own due diligence before making any financial or membership decisions.
            </p>

            <p>
              <strong>PrivateIQ makes no warranties or representations, express or implied, regarding the content on this
                site.</strong>
            </p>

            <p>
              All use of this site is at your own risk. PrivateIQ shall not be liable for any direct, indirect,
              incidental,
              consequential, or punitive damages arising from your use of this site.
            </p>

            <p>
              If you believe corrections are needed, please contact us at <a
                href="mailto:support@privateiq.golf">support@privateiq.golf</a>.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Register;